import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import uniqBy from '../../../utils/uniqBy';
import { MappingService } from '../../shared/services/mapping.service';
import { IGroupedAirports } from '../interfaces/igrouped-airports';

@Pipe({
  name: 'groupAirports'
})
export class GroupAirportsPipe implements PipeTransform {

  constructor(private _mappingService: MappingService) {
  }

  transform(value: any[]): Observable<IGroupedAirports> {
    return value ? this._mappingService.getMappings().pipe(
      map(e => {
        return Object.assign(e.airports.objects, e.harbours.objects, e.destinations.objects);
      }),
      map(e => value.map(x => {
        if (x === 'null') {
          return {Id: 'null', Name: 'Solo Soggiorno - Tour'};
        }
        return e[x];
      }).filter(x => x)
        .map(x => {
          x.parent = e[x.ParentID];
          return x;
        })),
      map(e => uniqBy(e, 'Id')),
      map(e => {
        const groupedApts: IGroupedAirports = {
          specialAirports: e.filter(x => x.Id === 'null'),
          specialHarbours: e.filter(x => x.Id > 2000000),
          specialBusses: e.filter(x => x.Id > 0 && x.Id < 1000000),
          groups: Object.values(e.filter(x => x.Id !== 'null' && (x.Id < 2000000 && x.Id > 1000000)).reduce((a, b) => {
            if (!a[b.ParentID]) {
              a[b.ParentID] = {};
              a[b.ParentID].name = b?.parent?.Name?.replace('Aeroporti', '')?.replace('Italia', '')?.trim();
              a[b.ParentID].airports = [];
            }
            a[b.ParentID].airports.push(b);
            return a;

          }, {}))
        };
        return groupedApts;
      })
    ) : null;
  }

}
